/**
 * Public API functions — no session token required.
 * Used for pre-authentication flows (signup, provider discovery).
 */

export interface PublicProvider {
  objectId: string;
  name: string;
  address?: string;
  city?: string;
  state?: string;
  country?: string;
  phone?: string;
  email?: string;
  logo?: string;
  emrType?: string;
}

export async function getProviders(): Promise<PublicProvider[]> {
  const res = await fetch('/api/parse/cloud', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      functionName: 'getProviders',
      params: { activeOnly: true, page: 1, limit: 20 },
    }),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || 'Failed to load providers');
  }

  const data = await res.json();
  const raw = data.result ?? data;
  // Cloud function returns { providers: [...] } or plain array
  const list = Array.isArray(raw) ? raw : (raw?.providers ?? []);
  return list;
}
